export const SET_FLAGS = 'flag/SET_FLAGS'
